<template>
	<div class="post-slider relative aspect-[16/9] select-none overflow-hidden rounded-2xl">
		<Swiper
			class="h-full w-full"
			space-between="16"
			:modules="[Pagination]"
			:pagination="{
				enabled: true
			}"
			@real-index-change="(s) => (swiperRealIndex = s.realIndex)"
		>
			<SwiperSlide v-for="image in post?.covers" :key="image.id!">
				<img :src="$config.public.baseUrl + image.path" alt="" class="h-full w-full rounded-2xl object-cover" />
			</SwiperSlide>
			<SwiperSlide v-for="video in post?.videos" :key="video.id!">
				<video
					:key="video.id!"
					ref="videoEls"
					:src="$config.public.baseUrl + video.path"
					alt=""
					controls
					class="h-full w-full rounded-2xl object-cover"
				/>
				<div
					v-if="!isVideoPlaying"
					class="absolute bottom-0 left-0 right-0 top-0 flex cursor-pointer items-center justify-center"
					@click="
						() => {
							if (!videoEl) return
							videoEl.play()
						}
					"
				>
					<Icon name="mdi:play-circle" class="bg-white h-16 w-16 rounded-full text-primary shadow-xl" />
				</div>
			</SwiperSlide>
		</Swiper>
	</div>
</template>

<script setup lang="ts">
import { Pagination } from "swiper/modules"
import type { Swiper } from "swiper"
import type { Post } from "~/models/post"

const props = defineProps<{
	post?: Post
}>()

const videoEls = shallowRef<HTMLVideoElement[]>()
const swiperRealIndex = ref(0)

const videoEl = computed(() => {
	const i = swiperRealIndex.value - (props.post?.covers?.length || 0)
	return videoEls.value?.[i] || null
})

const { playing: isVideoPlaying } = useMediaControls(videoEl)
</script>

<style>
:root {
	--swiper-navigation-color: #ea6939;
	--swiper-theme-color: #ea6939;
}

.post-slider .swiper-pagination-horizontal {
	@apply !bottom-auto !top-[8px];
}
</style>
